import { createFileRoute } from '@tanstack/react-router';
import { CONNECTOR_TABS, ConnectorDetailPage, type ConnectorTab } from '@/features/connectors/ConnectorDetailPage';

/** One connector: `?tab=overview|sensors|channels|settings|log`. */
export const Route = createFileRoute('/_authed/t/$tenantSlug/_shell/connectors/$connectorId')({
  validateSearch: (search: Record<string, unknown>): { tab?: ConnectorTab } => ({
    tab: CONNECTOR_TABS.includes(search.tab as ConnectorTab) ? (search.tab as ConnectorTab) : undefined,
  }),
  component: ConnectorDetailRoute,
});

function ConnectorDetailRoute() {
  const { tenant, me } = Route.useRouteContext();
  const { connectorId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ConnectorDetailPage
      tenant={tenant}
      me={me}
      connectorId={connectorId}
      tab={tab ?? 'overview'}
      onTab={(next) => void navigate({ search: { tab: next === 'overview' ? undefined : next }, replace: true })}
    />
  );
}
